"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSubdomain = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const config_1 = require("../../../assets/styles/config");
exports.StyledSubdomain = styled_components_1.default.p `
  border: 0;
  color: ${config_1.colors.thundercloud};
  cursor: text;
  font: ${config_1.fontSizes.base} ${config_1.fontFamilies.primary};
  margin: 0;
  padding: 0;
  text-align: start;
`;
